import React from "react";
import DynamicFlowVariablePanel from "./globalVars/DynamicFlowVariablePanel";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import PreRequestVariables from "./PreRequestVariables";

const VariablesPage = ({ action }) => {
  const prereqdesc = "Pre-Request Variables are initialized before the REST request is executed. These variables are accessible throughout the entire request lifecycle and can be used in the request preparation (e.g., setting headers or request body), during the request, and after the request is completed. They serve as a foundation for configuring the request and remain available for subsequent actions within the flow."
    
  return (
    <>
      <p className="ihub-action-tab-description">
        Variables can be defined and used like
        this: &#123;&#123; myVariable &#125;&#125;.
      </p>
      <p>
        <b>Note.</b> 'last', 'first' are reserved keywords and should not be
        used as variable names.
      </p>
      <Tabs>
        <TabList>
          <Tab>Pre-Request Variables</Tab>
          <Tab>Post-Request Variables</Tab>
        </TabList>
        <TabPanel>
          <div className="ihub-variable-tab-warpper">
            {prereqdesc}
            <PreRequestVariables action={action} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-variable-tab-warpper">
            <DynamicFlowVariablePanel action={action} />
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default VariablesPage;
